export default function isInEnum<T extends string>(
  enm: { [s: string]: T },
  value: string | null
): value is T {
  return (Object.values(enm) as (string | null)[]).includes(value);
}
